var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C17.4853 12 19.5 9.98528 19.5 7.5C19.5 5.01472 17.4853 3 15 3C12.5147 3 10.5 5.01472 10.5 7.5C10.5 9.98528 12.5147 12 15 12Z",
    fill: "#010F55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.19776 21.7403C4.90543 22.5023 5.16652 23.3565 5.8113 23.8569C8.34983 25.8271 11.538 27 15.0002 27C18.4659 27 21.657 25.8247 24.1968 23.8509C24.8413 23.35 25.1018 22.4957 24.809 21.7339C23.2951 17.7953 19.4763 15 15.0046 15C10.5305 15 6.70994 17.7984 5.19776 21.7403Z",
    fill: "#010F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoId);
export default __webpack_public_path__ + "static/media/no-id.d267a15fb32a728007fc1ffbc80877a9.svg";
export { ForwardRef as ReactComponent };